document.addEventListener('alpine:init', () => {
  Alpine.data('ArticleTOC', (config = {}) => ({
    items: [],
    activeId: null,
    activeParentId: null,
    mobileOpen: false,
    headings: [],
    contentSelector: config.contentSelector || '.js-article-toc-content',
    headingSelector: config.headingSelector || 'h2, h3',
    activeOffset: config.activeOffset || 120,
    onScroll: null,
    init() {
      this.$nextTick(() => this.build());
    },
    get hasItems() {
      return this.items.length > 0;
    },
    isActiveParent(id) {
      return this.activeParentId === id;
    },
    isActiveItem(id) {
      return this.activeId === id;
    },
    slugify(text) {
      return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/['"`]+/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
    },
    build() {
      const content = document.querySelector(this.contentSelector);
      if (!content) return;
      const headings = Array.from(
        content.querySelectorAll(this.headingSelector)
      );
      const usedIds = new Set();
      const tree = [];
      let currentH2 = null;

      headings.forEach((h) => {
        const text = h.textContent.trim();
        if (!text) return;
        let base = h.id || this.slugify(text);
        if (!base) return;
        let id = base;
        let suffix = 2;
        while (
          usedIds.has(id) ||
          (id !== h.id && document.getElementById(id))
        ) {
          id = `${base}-${suffix++}`;
        }
        usedIds.add(id);
        h.id = id;
        h.style.scrollMarginTop =
          'calc(var(--sticky-header-height, 0px) + 1rem)';

        const level = parseInt(h.tagName.substring(1), 10);
        if (level === 2) {
          const node = { id, text, level, children: [] };
          tree.push(node);
          currentH2 = node;
        } else if (level === 3) {
          const node = { id, text, level, parentId: currentH2 ? currentH2.id : id };
          if (currentH2) {
            currentH2.children.push(node);
          } else {
            // orphan H3 (no preceding H2) — render at top level
            tree.push({ ...node, children: [] });
          }
        }
      });

      this.items = tree;
      this.headings = headings;
      if (headings.length) this.bindScroll();
    },
    bindScroll() {
      let frame = null;
      this.onScroll = () => {
        if (frame) return;
        frame = requestAnimationFrame(() => {
          frame = null;
          this.updateActive();
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.updateActive();
    },
    updateActive() {
      let activeIdx = -1;
      for (let i = 0; i < this.headings.length; i++) {
        if (
          this.headings[i].getBoundingClientRect().top - this.activeOffset <=
          0
        ) {
          activeIdx = i;
        } else {
          break;
        }
      }
      if (activeIdx === -1 && this.headings.length) activeIdx = 0;

      const active = this.headings[activeIdx];
      this.activeId = active ? active.id : null;

      let parent = active;
      if (active && active.tagName === 'H3') {
        for (let i = activeIdx; i >= 0; i--) {
          if (this.headings[i].tagName === 'H2') {
            parent = this.headings[i];
            break;
          }
        }
      }
      this.activeParentId = parent ? parent.id : null;
    },
    scrollTo(id) {
      const el = document.getElementById(id);
      if (!el) return;
      this.mobileOpen = false;
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', `#${id}`);
    },
    destroy() {
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
      }
    },
  }));
});
